import React, { Component } from 'react';
import { Button, Icon, Spin } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route } from "react-router";

import { actions } from "store";
import { Page, PageHeader } from 'components/layout';
import { ActionButton } from "components/common";
import { ProfileForm } from 'components/blocks/Profile';
import ProfileMainScreen from './ProfileMainScreen';
import ProfileReviewListScreen from './ProfileReviewListScreen';


class ProfileDetailScreen extends Component {
  state = {
    id: null,
  };

  componentDidMount() {
    const { actions, match } = this.props;
    actions.profileDetailLoad({ id: match.params.id });
    this.setState({ id: match.params.id });
  }

  showEditForm = (item = null) => {
    const { actions } = this.props;
    actions.profileShowEditForm({ show: true, object: item });
  };

  delete = () => {
    const { actions } = this.props;
    const { id } = this.state;
    actions.profileDelete({ id });
  };

  render() {
    const { history, profile } = this.props;
    const detail = profile.detail || {};

    return (
      <Page>
        <Spin spinning={profile.updateStatus.isLoading}>
          <PageHeader
            history={history}
            title={detail.name}
            actions={[
              <Button onClick={() => this.showEditForm(detail)}>
                <Icon type="plus"/>
                <span>Редактировать</span>
              </Button>,
              <ActionButton
                actions={[
                  {
                    key: 'delete',
                    icon: 'delete',
                    title: 'Удалить',
                    action: this.delete,
                    confirm: {
                      title: 'Уверены, что хотите удалить?',
                      okText: 'Удалить',
                      cancelText: 'Отмена'
                    }
                  },
                ]}
              />
            ]}
            basePath={`/profile/${this.state.id}`}
            tabs={[
              { title: 'Детали', key: 'detail' },
              { title: 'Отзывы', key: 'reviews' },
            ]}
          />

          <Route exact path="/profile/:id" component={ProfileMainScreen}/>
          <Route exact path="/profile/:id/reviews" component={ProfileReviewListScreen}/>

          <ProfileForm/>
        </Spin>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    profile: state.profile,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.profile), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileDetailScreen);
